import { render, staticRenderFns } from "./category-filter.vue?vue&type=template&id=2df54345&scoped=true&"
import script from "./category-filter.vue?vue&type=script&lang=ts&"
export * from "./category-filter.vue?vue&type=script&lang=ts&"
import style0 from "./category-filter.vue?vue&type=style&index=0&id=2df54345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df54345",
  null
  
)

component.options.__file = "category-filter.vue"
export default component.exports